<script setup>
import { computed, useAttrs } from 'vue'
import { useFormFieldContext } from '@/composables/useFormFieldContext'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  label: { type: String, default: '' },
  id: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  invalid: { type: Boolean, default: null },
  density: { type: String, default: '' },
  ariaLabel: { type: String, default: '' },
})

const emit = defineEmits(['update:modelValue'])
const attrs = useAttrs()
const { resolveId, resolveDescribedby, resolveInvalid, resolveDensity } = useFormFieldContext()

const resolvedId = computed(() => resolveId(props.id))
const resolvedInvalid = computed(() => resolveInvalid(props.invalid))
const resolvedDensity = computed(() => resolveDensity(props.density))
const describedby = computed(() => resolveDescribedby(attrs['aria-describedby']))
</script>

<template>
  <label
    class="form-toggle"
    :class="{
      'form-toggle--compact': resolvedDensity === 'compact',
      'form-toggle--disabled': disabled,
      'form-toggle--on': modelValue,
      'is-invalid': resolvedInvalid,
    }"
  >
    <input
      :id="resolvedId"
      type="checkbox"
      role="switch"
      class="form-toggle-input"
      :checked="modelValue"
      :disabled="disabled"
      :aria-checked="modelValue"
      :aria-invalid="resolvedInvalid ? true : undefined"
      :aria-describedby="describedby"
      :aria-label="ariaLabel || label || undefined"
      v-bind="{ ...attrs, class: undefined }"
      @change="$emit('update:modelValue', $event.target.checked)"
    />
    <span class="form-toggle-track" aria-hidden="true">
      <span class="form-toggle-thumb" />
    </span>
    <span v-if="label" class="form-toggle-label">{{ label }}</span>
    <slot />
  </label>
</template>
